<p-dialog
  [(visible)]="driversService.modalActive"
  [modal]="true"
  [resizable]="false"
  [style]="{
    width: '35%',
    minWidth: '400px',
    maxWidth: '90vw'
  }"
>
  <ng-template class="p-dialog-title" pTemplate="header">
    <div>
      <i class="fa fa-user me-2" aria-hidden="true"></i>
      <strong
        [innerHTML]="
          driversService.action == 'edit'
            ? ('DRIVERS.ACTION.CONFIGURE_DRIVER' | translate)
            : ('DRIVERS.MESSAGE.ADD_NEW_DRIVER' | translate)
        "
      >
      </strong>
    </div>
  </ng-template>

  <form
    [formGroup]="driversForm"
    (submit)="onSubmit()"
    (keydown.enter)="$event.preventDefault()"
    autocomplete="off"
    class="mb-4"
  >
    <div class="container py-3 driver-form-wrapper">
      <!-- Nombre completo -->
      <div class="mb-3">
        <label for="name_driver" class="form-label">
          {{ "FIELDS.FULL_NAME" | translate }}
          <span class="required-asterisk" *ngIf="isFieldRequired('nombre')"
            >*</span
          >
        </label>
        <input
          id="name_driver"
          type="text"
          pInputText
          class="form-control p-inputtext"
          [class.is-invalid]="isFieldInvalid('nombre')"
          [class.required-input]="isFieldRequired('nombre')"
          placeholder="Ingresa el nombre completo del conductor"
          formControlName="nombre"
          autocomplete="off"
          cdkFocusInitial
        />
        <div class="invalid-feedback" *ngIf="getErrorMessage('nombre')">
          {{ getErrorMessage("nombre") }}
        </div>
      </div>

      <!-- Tipo y número de documento -->
      <div class="row g-3">
        <div class="col-md-6">
          <label for="tipo-documento" class="form-label">
            {{ "DRIVERS.LABELS.DOCUMENT_TYPE" | translate }}
            <span
              class="required-asterisk"
              *ngIf="isFieldRequired('tipo_documento')"
              >*</span
            >
          </label>
          <p-dropdown
            id="tipo-documento"
            [filter]="true"
            [options]="typeDocuments"
            optionLabel="label"
            optionValue="value"
            formControlName="tipo_documento"
            [showClear]="true"
            [appendTo]="'body'"
            (onChange)="
              changeTypeDocument($event.value, driversService.action === 'edit')
            "
            [placeholder]="'DRIVERS.LABELS.SELECT_DOCUMENT_TYPE' | translate"
            styleClass="w-100"
            [class.is-invalid]="isFieldInvalid('tipo_documento')"
            [class.required-input]="isFieldRequired('tipo_documento')"
          >
          </p-dropdown>
          <div
            class="invalid-feedback"
            *ngIf="getErrorMessage('tipo_documento')"
          >
            {{ getErrorMessage("tipo_documento") }}
          </div>
        </div>
        <div class="col-md-6">
          <label for="dni_driver" class="form-label">
            {{ "DRIVERS.LABELS.DOCUMENT_NUMBER" | translate }}
            <span class="required-asterisk" *ngIf="isFieldRequired('dni')"
              >*</span
            >
          </label>
          <input
            id="dni_driver"
            type="text"
            pInputText
            class="form-control p-inputtext"
            [class.is-invalid]="isFieldInvalid('dni')"
            [class.required-input]="isFieldRequired('dni')"
            [class.disabled-input]="!driversForm.get('tipo_documento')?.value"
            placeholder="Ingresa el número de documento"
            formControlName="dni"
            autocomplete="off"
            [maxlength]="nroDocumentMaxLength"
          />
          <div class="invalid-feedback" *ngIf="getErrorMessage('dni')">
            {{ getErrorMessage("dni") }}
          </div>
        </div>
      </div>

      <!-- Licencia -->
      <div class="mt-3">
        <label for="licencia_driver" class="form-label">
          {{ "DRIVERS.LABELS.LICENSE_NUMBER" | translate }}
        </label>
        <input
          id="licencia_driver"
          type="text"
          pInputText
          class="form-control p-inputtext"
          placeholder="Ingrese número de licencia"
          formControlName="nro_licencia"
          autocomplete="off"
        />
      </div>

      <!-- Teléfono -->
      <div class="mt-3">
        <label for="telefono_driver" class="form-label">
          {{ "DRIVERS.LABELS.PHONE_NUMBER" | translate }}
        </label>
        <input
          id="telefono_driver"
          type="text"
          pInputText
          class="form-control p-inputtext"
          [class.is-invalid]="isFieldInvalid('nro_cellphone')"
          placeholder="Ingrese número de celular"
          formControlName="nro_cellphone"
          autocomplete="off"
          maxlength="9"
        />
        <div class="invalid-feedback" *ngIf="getErrorMessage('nro_cellphone')">
          {{ getErrorMessage("nro_cellphone") }}
        </div>
      </div>

      <!-- Código CIPIA -->
      <div class="mt-3" *appHasPermission="'drivers_view_codecipia'">
        <label for="codigo_cipia" class="form-label">
          {{ "DRIVERS.LABELS.CIPIA_CODE" | translate }}
        </label>
        <p-dropdown
          id="codigo_cipia"
          [filter]="true"
          [options]="icipias"
          optionLabel="value"
          optionValue="id"
          formControlName="nro_cipia"
          [showClear]="true"
          [appendTo]="'body'"
          [placeholder]="'DRIVERS.LABELS.SELECT_CIPIA_CODE' | translate"
          styleClass="w-100"
        >
        </p-dropdown>
      </div>

      <!-- Llave iButton -->
      <div class="mt-3" *appHasPermission="'drivers_view_ibutton'">
        <label for="nro_llave" class="form-label">
          {{ "DRIVERS.LABELS.KEY_NUMBER" | translate }}
        </label>
        <p-dropdown
          id="nro_llave"
          [filter]="true"
          [options]="ibuttons"
          optionLabel="value"
          optionValue="id"
          formControlName="nro_llave"
          [showClear]="true"
          [appendTo]="'body'"
          [placeholder]="'DRIVERS.LABELS.SELECT_IBUTTON_KEY' | translate"
          styleClass="w-100"
        >
        </p-dropdown>
      </div>

      <!-- Botones -->
      <div
        class="row justify-content-center mt-4 pt-2 panel-izq-container-footer"
      >
        <div class="col-4">
          <button
            type="button"
            class="btn-gl-cancel btn-dark-hover w-100"
            (click)="driversService.modalActive = false"
          >
            {{ "GENERAL.CANCEL" | translate }}
          </button>
        </div>
        <div class="col-4">
          <button
            type="submit"
            class="btn-gl-save btn-dark-hover w-100"
            [disabled]="driversForm.invalid"
          >
            {{ "GENERAL.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
